var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFineLines = function SvgFineLines(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 18,
    viewBox: "0 0 48 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H28",
    stroke: "#283333",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5H32",
    stroke: "#283333",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H38",
    stroke: "#283333",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H42",
    stroke: "#283333",
    strokeWidth: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17H48",
    stroke: "#283333",
    strokeWidth: 0.75
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFineLines);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCA0OCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMUgyOCIgc3Ryb2tlPSIjMjgzMzMzIiBzdHJva2Utd2lkdGg9IjAuNzUiLz4KPHBhdGggZD0iTTYgNUgzMiIgc3Ryb2tlPSIjMjgzMzMzIiBzdHJva2Utd2lkdGg9IjAuNzUiLz4KPHBhdGggZD0iTTEwIDlIMzgiIHN0cm9rZT0iIzI4MzMzMyIgc3Ryb2tlLXdpZHRoPSIwLjc1Ii8+CjxwYXRoIGQ9Ik0xNiAxM0g0MiIgc3Ryb2tlPSIjMjgzMzMzIiBzdHJva2Utd2lkdGg9IjAuNzUiLz4KPHBhdGggZD0iTTIwIDE3SDQ4IiBzdHJva2U9IiMyODMzMzMiIHN0cm9rZS13aWR0aD0iMC43NSIvPgo8L3N2Zz4K";